// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/platform.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/platform.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo aula-courses-app
//     node fleet/fleet.ts check --repo aula-courses-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Agnostic platform detection.
 */

export type PlatformOS = "ios" | "android" | "web" | "macos" | "windows" | "linux";

export function getPlatformOS(): PlatformOS {
  if (typeof navigator !== "undefined") {
    const nav = navigator as Navigator | { product: string };
    if ("product" in nav && nav.product === "ReactNative") {
      return "ios";
    }
  }

  if (typeof globalThis === "undefined" || !("window" in globalThis)) {
    return "linux"; // Server/Node default
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
    return "ios";
  }
  if (userAgent.includes("android")) {
    return "android";
  }
  if (userAgent.includes("macintosh")) {
    return "macos";
  }
  if (userAgent.includes("windows")) {
    return "windows";
  }
  if (userAgent.includes("linux")) {
    return "linux";
  }

  return "web";
}

export const isWeb = typeof globalThis !== "undefined" && "window" in globalThis;
export const isNative = !isWeb;

declare global {
  interface ImportMeta extends Record<string, unknown> {
    readonly __brand?: never;
  }
  var __DEV__: boolean | undefined;
}

function getIsDev(): boolean {
  // oxlint-disable-next-line typescript/no-unnecessary-condition
  const env: unknown = import.meta === undefined ? undefined : import.meta.env;
  const isModeDev = typeof env === "object" && env && Reflect.get(env, "MODE") === "development";
  // oxlint-disable-next-line typescript/prefer-optional-chain
  if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
    return true;
  }
  const isGlobalDev = typeof __DEV__ === "undefined" ? false : __DEV__;
  return isModeDev ? true : isGlobalDev;
}

export const isDev = getIsDev();
